/* eslint-disable */
import config from "../../../config";
import makeAPIRequest from "../../../services/makeRequest";

async function getMarketLocationData(colocation, accessToken, year = null) {
  let API_ENDPOINT = `${config["API_BASE_ENDPOINT"]}/admin/impactdashboard/stats/${colocation}`;
  if (year) {
    API_ENDPOINT += `?year=${year}`;
  }

  const response = await makeAPIRequest(API_ENDPOINT, "GET", null, accessToken);
  const jsonResponse = await response.json();
  return jsonResponse;
}

export default getMarketLocationData;
